<iframe class="page" src="https://manga-web-translator-client-5ce8f.ondigitalocean.app/" title="W3Schools Free Online Web Tutorials"></iframe>

<style>
    .page {
        width: 100vw;
        height: 100vh;
    }
</style>